"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const crypto_1 = tslib_1.__importDefault(require("crypto"));
const logger_1 = require("@osmosys/logger");
const base64url_1 = tslib_1.__importDefault(require("base64url"));
exports.getTransactionToken = () => {
    return new Promise(resolve => crypto_1.default.randomBytes(48, (error, buf) => {
        if (error) {
            logger_1.logger.error({ error }, 'Error in getTransactionToken');
            throw new Error('Internal error: Unable to get transaction token');
        }
        resolve(base64url_1.default(buf).replace(/-|_/gm, ''));
    }));
};
//# sourceMappingURL=getTransactionToken.js.map